import { Injectable } from '@angular/core';

import { CustomsTransactionType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomsTransactionTypeService extends TmsWebBaseEditService<
  CustomsTransactionType,
  CustomsTransactionType
> {
  constructor() {
    super('CustomsTransactionType', $localize`Customs Transaction Type`);
  }
}
